﻿<template>
    <span class="diff">
        <b :class="[percentageColor]">
            <component :is="percentageArrow" class="bs-icon" :size="16" :stroke="2" role="img" :aria-label="value === 0 ? 'Unchanged' : value < 0 ? 'Falling' : 'Rising'" focusable="false" /> {{ label }}
        </b>
        <template v-if="showLabel">
            from {{ fromNow(from) }}
        </template>
    </span>
</template>
<script>
import { IconArrowUp, IconArrowDown, IconCircleDot } from "@tabler/icons-vue";
    import utils from "../utils/units";
    import * as common from "../utils/common";

    import { mapState, mapGetters } from 'vuex';
    export default {
 components: { IconArrowUp, IconArrowDown, IconCircleDot },
        props: {
            value: {
                type: Number,
                required: true
            },
            from: {
                required: true
            },
            showLabel: {
                required: false,
                default: true
            },
            reversed: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            ...mapState(["currentUser"]),
            ...mapGetters(["isMetric"]),
            //computedValue() {
            //    return this.isMetric ? this.value : utils.toOz(this.value);
            //},
            label() {
                return common.round(this.value * 100, 1) + "%";
            },
            percentageArrow() {
                return this.value == 0 ? IconCircleDot : this.value < 0.0 ? IconArrowDown : IconArrowUp
            },
            percentageColor() {
                if (this.reversed === true) {
                    return this.value == 0 ? 'color-fix' : this.value > 0.0 ? 'color-down' : 'color-up'
                }

                return this.value == 0 ? 'color-fix' : this.value < 0.0 ? 'color-down' : 'color-up'
            }
        }
    }
</script>
<style scoped>
.color-up { color: var(--bs-color-trend-up); }
.color-down { color: var(--bs-color-trend-down); }
.color-fix { color: var(--bs-color-trend-steady); }
</style>
